// Font family constants for JavaScript usage
// This matches the font stack defined in app/assets/stylesheets/variables.module.scss
//
// Usage Examples:
// - FONT_FAMILY_SANS: Use with MUI theme configuration
// - FONT_FAMILY_SANS_CSS: Use with CSS-in-JS libraries like OpenEdge
// - FONT_FAMILY_SANS_STRING: Use with libraries like Stripe Elements

// Font stack as a JavaScript array (for libraries like MUI that expect arrays)
export const FONT_FAMILY_SANS = [
  "Geist",
  "Inter",
  "BlinkMacSystemFont",
  "-apple-system",
  "Segoe UI",
  "Roboto",
  "Oxygen",
  "Ubuntu",
  "Cantarell",
  "Fira Sans",
  "Droid Sans",
  "Helvetica Neue",
  "Helvetica",
  "Arial",
  "sans-serif",
];

// Font stack as a CSS string (for direct CSS usage and CSS-in-JS libraries)
export const FONT_FAMILY_SANS_CSS =
  '"Geist", "Inter", BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif';

// Font stack as a JavaScript string (for libraries like Stripe Elements that expect unquoted strings)
export const FONT_FAMILY_SANS_STRING =
  "Geist, Inter, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
